import React, { useState, useEffect, useCallback } from "react";
import { Divider, Form, Grid, Image, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import { image } from "../../../../assets";
import { User, Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./UserForm.form";
import { buildStorageUrl, withEmptyOption } from "../../../../utils";
import "./UserForm.scss";
const userController = new User();
const roleController = new Role();

export function UserForm(props) {
  const { close, onReload, user } = props;
  const { accessToken } = useAuth();

  const [rolesOptions, setRolesOptions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setRolesOptions([]);
        const response = await roleController.getRoles();
        const options = response.map((role) => ({
          value: role.id,
          text: role.name,
        }));
        setRolesOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [user, accessToken]);

  const formik = useFormik({
    initialValues: initialValues(user),
    validationSchema: validationSchema(user),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (user) {
          await userController.updateUser(user.id, formValue);
        } else {
          await userController.createUser(formValue);
        }
        onReload();
        close();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    formik.setFieldValue("avatar", URL.createObjectURL(file));
    formik.setFieldValue("fileAvatar", file);
  });

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png",
    onDrop,
  });

  const getAvatar = () => {
    if (formik.values.fileAvatar) {
      return formik.values.avatar;
    } else if (formik.values.avatar) {
      return buildStorageUrl(formik.values.avatar);
    }
    return image.noAvatar;
  };

  return (
    <Form className="user-form" onSubmit={formik.handleSubmit}>
      <Grid columns={2} stackable>
        <Grid.Row className="student-form__data">
          <Grid.Column>
            <div className="user-form__avatar">
              <div {...getRootProps()} className="user-form__avatar-dropzone">
                <input {...getInputProps()} />
                <Image
                  avatar
                  className="user-avatar"
                  centered
                  size="small"
                  src={getAvatar()}
                />
                <div className="user-form__avatar-overlay">
                  <Icon name="camera" size="big" />
                  <p>Cambiar foto</p>
                </div>
              </div>
            </div>

            <Form.Input
              name="firstname"
              label="Nombre"
              onChange={formik.handleChange}
              value={formik.values.firstname}
              error={formik.errors.firstname}
              fluid
            />

            <Form.Input
              name="lastname"
              label="Apellido paterno"
              onChange={formik.handleChange}
              value={formik.values.lastname}
              error={formik.errors.lastname}
              fluid
            />
            <Form.Input
              name="secondLastname"
              label="Apellido materno"
              onChange={formik.handleChange}
              value={formik.values.secondLastname}
              error={formik.errors.secondLastname}
              fluid
            />

            <Form.Input
              name="dni"
              label="DNI"
              onChange={formik.handleChange}
              value={formik.values.dni}
              error={formik.errors.dni}
              fluid
            />
            <Form.Select
              className="edunova-select"
              name="gender"
              label="Género"
              placeholder="Selecciona un género"
              clearable
              options={withEmptyOption(
                [
                  { value: "M", text: "Masculino" },
                  { value: "F", text: "Femenino" },
                ],
                "Selecciona un género"
              )}
              onChange={(e, { value }) => formik.setFieldValue("gender", value)}
              value={formik.values.gender}
              error={formik.errors.gender}
              fluid
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Select
              className="edunova-select"
              name="roleId"
              label="Rol"
              placeholder="Selecciona un rol"
              clearable
              options={withEmptyOption(rolesOptions, "Selecciona un rol")}
              onChange={(e, { value }) => formik.setFieldValue("roleId", value)}
              value={formik.values.roleId}
              error={formik.errors.roleId}
              fluid
            />

            <Form.Input
              name="phone"
              label="Teléfono"
              onChange={formik.handleChange}
              value={formik.values.phone}
              error={formik.errors.phone}
              fluid
            />
            <Form.Input
              name="phone2"
              label="Teléfono adicional"
              onChange={formik.handleChange}
              value={formik.values.phone2}
              error={formik.errors.phone2}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider className="student-form__separator" />
      <Form.Input
        name="email"
        label="Correo electrónico"
        onChange={formik.handleChange}
        value={formik.values.email}
        error={formik.errors.email}
        fluid
      />

      <Form.Input
        type="password"
        name="password"
        label="Contraseña"
        onChange={formik.handleChange}
        value={formik.values.password}
        error={formik.errors.password}
        fluid
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {user ? "Actualizar usuario" : "Crear usuario"}
      </Form.Button>
    </Form>
  );
}
